export enum ExportableDealDetailsTabs {
  summary = 'Summary',
  bidResults = 'Bid Results',
  bidinfo = 'Prelim Bids',
  analytics = 'Analytics',
  comments = 'Comments',
  designations = 'Designations',
  allotments = 'Allotments'
}

export enum ExportableMonitorTabs {
  activeCalendar = 'My Active Calendar',
  activeDeals = 'My Active Deals',
  documents = 'Documents'
}
export enum ExportableManagerTabs {
  activeCalendar = 'My Active Calendar',
  activeDeals = 'My Active Deals'
}

export enum ExportableBidcompTabs {
  bidCompDeals = 'All'
}

export interface ExportServiceOption {
  name:
    | ExportableDealDetailsTabs
    | ExportableMonitorTabs
    | ExportableManagerTabs
    | ExportableBidcompTabs;
  isCheckedByDefault: boolean;
  isDisabled: boolean;
  configOptions: ExportServiceConfigOption<string>[];
  updatedWithConfigOpts?: boolean;
}

export interface ExportModalOption extends ExportServiceOption {
  isChecked: boolean;
  configOptions: ExportModalConfigOption<string>[];
}

export interface ExportServiceConfigOption<T> {
  name: T;
  isCheckedByDefault: boolean;
  isDisabled: boolean;
}

export interface ExportModalConfigOption<T>
  extends ExportServiceConfigOption<T> {
  isChecked: boolean;
}

export enum ExportModalAction {
  cancel = 'cancel',
  export = 'export'
}

export class ExportAction {
  public action = ExportModalAction.export;

  constructor(public options: ExportModalOption[]) {}
}

export class CancelAction {
  action = ExportModalAction.cancel;
}
